import { useEffect } from 'react';
import { IconButton, IconButtonStyles, Icons } from '@silverfort/sf-components';
import { useTowerLayout } from '../../../TowerLayout/TowerLayoutProvider';

export const usePageLayout = (title: string, onBackClicked: () => void) => {
    const { clearLayout, setLayoutHeader, setLayoutContentLeft } = useTowerLayout();

    useEffect(() => {
        setLayoutContentLeft(
            <IconButton
                buttonStyle={IconButtonStyles.Secondary}
                className="flex items-center"
                icon={Icons.ArrowBack}
                onClick={onBackClicked}
            />
        );
        setLayoutHeader(title);

        return clearLayout;
    }, [clearLayout, onBackClicked, setLayoutContentLeft, setLayoutHeader, title]);
};
